module.exports = __webpack_public_path__ + "img/add.befc1c63.svg";